import React from 'react';
import { BellRingIcon, CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { FounderNote } from './FounderNote';
import { images } from '../data/content';
import type { HeroCopy } from '../data/heroVersions';
import type { LandingActions } from '../types/actions';
interface HeroProps extends Pick<LandingActions, 'onFormCta'> {
  copy: HeroCopy;
}
export function Hero({
  copy,
  onFormCta
}: HeroProps) {
  return <section id="top" className="w-full bg-white" data-id="element-125" data-mp="128yye9fizpx2">
      <div className="mx-auto grid max-w-content gap-10 px-4 pb-14 pt-7 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-16 lg:pt-16" data-id="element-126" data-mp="xanqi48sjphh">
        <div data-id="element-127" data-mp="sde3ev8vjpwt">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-accent md:text-xs" data-id="element-128" data-mp="sd47ys528qjq">
            {copy.eyebrow}
          </p>

          <h1 className="mt-3 font-display text-[30px] font-semibold leading-[1.08] tracking-[-0.03em] text-ink sm:text-[40px] lg:text-[52px]" data-id="element-129" data-mp="3d2l9jc5qb50p">
            {copy.headline.map((line, i) => <span key={line} className={`block ${i === copy.headline.length - 1 ? 'text-accent' : ''}`} data-id="element-130" data-mp="3j893p1w0vrk9" data-mpi={i}>
                {line}
              </span>)}
          </h1>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-600 md:mt-6 md:text-[17px]" data-id="element-131" data-mp="39al7s8moke0i">
            {copy.intro}
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center md:mt-8" data-id="element-132" data-mp="3e7uydrlt2vpx">
            <Button onClick={() => onFormCta('hero_primary')} fullWidth className="sm:w-auto" data-id="element-133" data-mp="30h9crv4yw7oc">
              {copy.primaryCta}
            </Button>
          </div>

          <ul className="mt-5 flex flex-col gap-1.5 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-5 sm:gap-y-2" data-id="element-134" data-mp="2qloea6z3xpjc">
            {copy.microProof.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-ink-400" data-id="element-135" data-mp="2hk8522k13tgp">
                <CheckIcon className="mt-[2px] h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-136" data-mp="2ljpc30f3synz" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-137" data-mp="nb1kl4ct1rwf">
          <div className="overflow-hidden rounded-2xl bg-canvas" data-id="element-138" data-mp="n9qf903poc37">
            <img src={images.hero} alt="Arizona real estate agent standing outside a modern desert home at sunset" width={1680} height={945} loading="eager" decoding="async" style={{
            objectPosition: '74% 22%'
          }} className="h-[320px] w-full object-cover sm:h-[420px] lg:h-[560px]" data-id="element-139" data-mp="ibgor2sxlznx" />
          </div>

          {/* Subtle workflow overlay: agent empowerment plus technology */}
          <div className="absolute -bottom-5 left-3 w-[86%] max-w-[340px] rounded-xl border border-line bg-white p-3.5 shadow-[0_18px_40px_-24px_rgba(11,26,43,0.45)] sm:left-6" data-id="element-140" data-mp="x1w789tyqtie">
            <div className="flex items-center gap-2" data-id="element-141" data-mp="3hrlkwjixk99i">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-soft" data-id="element-142" data-mp="3hq23uqpg9u6o">
                <BellRingIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-143" data-mp="1xb5o89ocuje0" />
              </span>
              <p className="text-[13px] font-semibold text-ink" data-id="element-144" data-mp="218tols8th4da">Next best action</p>
              <span className="ml-auto text-[11px] font-medium text-ink-400" data-id="element-145" data-mp="268fybrpfs2hc">Auto-assigned</span>
            </div>
            <p className="mt-2.5 text-[13px] leading-snug text-ink-600" data-id="element-146" data-mp="2b2sm2dxy3zyw">
              New Scottsdale inquiry routed to you. First text sent, call reminder set for 4:15 PM.
            </p>
            <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-line" data-id="element-147" data-mp="2kx2ge16g78c9">
              <div className="h-full w-[72%] rounded-full bg-accent" data-id="element-148" data-mp="2p10f4arv2h4s" />
            </div>
          </div>
        </div>
      </div>

      <FounderNote data-id="element-149" data-mp="2txhbfs97s1sy" />
    </section>;
}